import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base';
export default function usePlaceholder(context) {
  var _useBreakpointValue;

  const isAustralia = context.country === 'Australia';
  const isCentre = !!context.centre;
  const isMobile = (_useBreakpointValue = useBreakpointValue([true, false, false], DEFAULT_BREAKPOINT)) !== null && _useBreakpointValue !== void 0 ? _useBreakpointValue : false; // N.B. some of these conditions are redundant, but I think it's easiest
  // to reason about one case at a time.

  if (isMobile && isAustralia && isCentre) {
    return 'Search for centres, stores...';
  } else if (isMobile && isAustralia && !isCentre) {
    return 'Search for centres, stores...';
  } else if (isMobile && !isAustralia && isCentre) {
    return 'Search for centres, stores...';
  } else if (isMobile && !isAustralia && !isCentre) {
    return 'Search for centres';
  } else if (!isMobile && isAustralia && isCentre) {
    return 'Search for centres, stores, services and more';
  } else if (!isMobile && isAustralia && !isCentre) {
    return 'Search for centres, stores, products and more';
  } else if (!isMobile && !isAustralia && isCentre) {
    return 'Search for centres, stores, services and more';
  } else {
    // Desktop, New Zealand, National
    return 'Search for centres';
  }
}